<template>
  <div id="project__color">
      <ul class="status-bar">
          <li 
          title="Color"
          v-b-tooltip.hover.html
          :style="{backgroundColor: projectColor}">
          </li>
      </ul>
  </div>
</template>

<script>
export default {
    props: ['project'],
    computed: {
        _() {
            return _
        },
        projectColor() {
            let colorField = _.filter(this.project.customFields, {field_key: 'color_picker'});
            let color = colorField.length > 0 ? colorField[0].value : 'transparent';
            return color;
        }
    },
    methods: {
    }
}
</script>

<style>

</style>